import React from "react";
import { Snackbar } from "@origin-digital/ods-core";
import ChangeRequestContext from "src/context/ChangeRequestContext";

export const SnackbarSection = () => {
  const { displayingSnackbar, setDisplayingSnackbar } =
    React.useContext(ChangeRequestContext);
  return displayingSnackbar ? (
    <Snackbar
      data-id="snackbar"
      open
      showClose
      tone={displayingSnackbar.tone}
      autoHideDuration={5000}
      onClose={() => setDisplayingSnackbar(null)}
      align="left"
    >
      {displayingSnackbar.message}
    </Snackbar>
  ) : null;
};
